import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UploadStateService {
  private uploading = false;
  private scanning = false;

  setUploading(value: boolean): void {
    this.uploading = value;
  }

  isUploading(): boolean {
    return this.uploading;
  }

  setScanning(value: boolean): void {
    this.scanning = value;
  }

  isScanning(): boolean {
    return this.scanning;
  }

  isBusy(): boolean {
    return this.uploading || this.scanning;
  }
}
